export const FOOTBALL_TABS = {
  FIXTURES: 'fixtures',
  STANDINGS: 'standings',
  PLAYERS: 'players'
};

export const DEFAULT_GAMES_PAGINATION = {
  currentPage: 1,
  perPage: 16,
  totalPages: 1
};

export const DEFAULT_PLAYERS_PAGINATION = {
  currentPage: 1,
  perPage: 16,
  totalPages: 1
};
